import { Inject, Injectable } from '@angular/core';
import { DEVSTROUPE_CONFIG } from '@devstroupe/services/config/config.constants';
import { StorageKeysService } from 'app/shared/services/storage-keys.service';
import { merge } from 'lodash-es';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DevstroupeConfigService {
    private _config: BehaviorSubject<any>;

    /**
     * Constructor
     */
    constructor(@Inject(DEVSTROUPE_CONFIG) config: any, private _storageKeysService: StorageKeysService) {
        // Private
        this._config = new BehaviorSubject(config);

        // Set the initial config
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for config
     */
    set config(value: any) {
        // Merge the new config over to the current config
        const config = merge({}, this._config.getValue(), value);
        localStorage.setItem(this._storageKeysService.scheme, config.scheme);

        // Execute the observable
        this._config.next(config);
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    get config$(): Observable<any> {
        return this._config.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resets the config to the default
     */
    reset(): void {
        // Set the config
        this._config.next(this.config);
    }
}
